export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";